import { Grid, Typography } from '@material-ui/core';
import React, { useCallback, useMemo } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';

import useResetPassword from 'core/hooks/useResetPassword';
import resetPasswordSchema, { ResetPasswordSchema } from 'core/schemas/resetPassword';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';

const Container = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
`;

export default function ResetPassword({
  location,
  match,
  history
}: RouteComponentProps<{ token: string }>) {
  const reset = useResetPassword();
  const getParams = useMemo(() => new URLSearchParams(location.search), [
    location.search
  ]);

  const onSubmit: FormSubmitHandler<ResetPasswordSchema> = useCallback(
    (payload, form) =>
      reset(payload)
        .then(() => {
          switch (getParams.get('role')) {
            case 'employee':
              return history.push('/welcome/employee');

            case 'customer':
              return history.push('/welcome/customer');

            case 'admin':
            default:
              return history.push({
                pathname: '/login',
                search: `?email=${payload.email}`
              });
          }
        })
        .catch(form.setErrors),
    [getParams, history, reset]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        email: getParams.get('email'),
        token: match.params.token
      }}
      validationSchema={resetPasswordSchema}
    >
      <Grid container component={Container} direction="column" spacing={4}>
        <Grid item>
          <Typography variant="h1">Vaihda salasana</Typography>
        </Grid>

        <Grid item>
          <InputField
            type="password"
            name="password"
            autoFocus
            placeholder="Syötä salasana"
            margin="none"
          />
        </Grid>

        <Grid item>
          <InputField
            type="password"
            name="password_confirmation"
            placeholder="Syötä salasana uudelleen"
            margin="none"
          />
        </Grid>

        <Grid item>
          <SubmitButton variant="contained" color="primary" fullWidth>
            Vaihda salasana
          </SubmitButton>
        </Grid>
      </Grid>
    </Form>
  );
}
